// based on rc-cascader 0.17.4
import Cascader from './Cascader';
export default Cascader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-cascader/index.js
// module id = null
// module chunks = 